import { Flex } from '@mantine/core';

import { IPSecurityUsers } from './components/ip-security-users';
import { IPSecurityAdm } from './components/ip-security-adm';
import { SessionDuration } from './components/session-duration';
import { PasswordLimit } from './components/password-limit';
import { PasswordStrength } from './components/password-strength';
import { useStyles } from '../../../styles';
import { isSaaS } from '@/lib/utils/access';
import { useAppSelector } from '@hooks/redux/redux';
import { ShareLinks } from '@/containers/pages/filials/edit/components/tabs/security/components/share-links';
import { RestrictRoomsByRoles } from '@/containers/pages/filials/edit/components/tabs/security/components/restrict-rooms-by-roles';
import { SettingSIEMSystem } from '@/containers/pages/filials/edit/components/tabs/security/components/setting-siem-system';
import { DlpAntivirus } from '@/containers/pages/user/feature/edit-user/components/sections/DlpAntivirus';

const SecurityPage = () => {
  const { classes } = useStyles();
  const { Settings } = useAppSelector((state) => state.userInfo);

  return (
    <Flex className={classes.container} direction="column">
      <DlpAntivirus />
      <SettingSIEMSystem />
      <ShareLinks />
      <RestrictRoomsByRoles />
      <IPSecurityUsers />
      <IPSecurityAdm />
      <SessionDuration />
      <PasswordLimit />
      {!isSaaS(Settings) && <PasswordStrength />}
    </Flex>
  );
};

export default SecurityPage;
